var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatWeDo3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.132,
    height: 17.898,
    viewBox: "0 0 34.132 17.898",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-residential-6242380",
    transform: "translate(0 -23.752)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M76.743,55.656h1.751a.341.341,0,0,0,.341-.341v-5.62a.341.341,0,0,0-.341-.341H76.743a.341.341,0,0,0-.341.341v5.62A.341.341,0,0,0,76.743,55.656Zm.341-5.62h1.068v4.938H77.085Z",
    transform: "translate(-50.325 -16.863)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_386",
    "data-name": "Path 386",
    d: "M18.561,49.353H16.81a.341.341,0,0,0-.341.341v5.62a.341.341,0,0,0,.341.341h1.751a.341.341,0,0,0,.341-.341v-5.62A.341.341,0,0,0,18.561,49.353Zm-.341,5.62H17.152V50.036H18.22Z",
    transform: "translate(-10.848 -16.863)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_387",
    "data-name": "Path 387",
    d: "M46.771,38.824H41.241a.341.341,0,0,0-.341.341V40.64a.341.341,0,0,0,.341.341h5.529a.341.341,0,0,0,.341-.341V39.165A.341.341,0,0,0,46.771,38.824ZM46.429,40.3H41.583v-.792h4.847Z",
    transform: "translate(-26.94 -9.928)",
    fill: "#1c1c74"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_388",
    "data-name": "Path 388",
    d: "M33.791,39.585H30.123V31.357a.341.341,0,0,0-.341-.341H25.148V29.238c0-.006,0-.012,0-.018V27.244a.337.337,0,0,0-.025-.125s0,0,0-.005A.157.157,0,0,0,25.1,27.1.338.338,0,0,0,25.042,27l0,0A11.409,11.409,0,0,0,9.091,27l0,0a.338.338,0,0,0-.062.09c0,.007-.01.013-.013.02v0a.33.33,0,0,0-.026.128V29.22c0,.006,0,.012,0,.018v1.778H4.35a.341.341,0,0,0-.341.341v8.228H.341A.341.341,0,0,0,0,39.926v1.382a.341.341,0,0,0,.341.341H33.791a.341.341,0,0,0,.341-.341V39.926A.341.341,0,0,0,33.791,39.585ZM29.441,31.7v7.887H25.148V31.7Zm-8.072,7.887V32.831a.341.341,0,0,0-.341-.341H13.1a.341.341,0,0,0-.341.341v6.754h-3.1V29.532c0-.006,0-.012,0-.018v-.128a10.722,10.722,0,0,1,14.791,0v.128a.155.155,0,0,0,0,.018V39.585h-3.1Zm-7.924,0V33.173h3.279v6.412Zm3.962-6.412h3.279v6.412H17.407ZM24.461,27.4V28.47a11.394,11.394,0,0,0-14.791,0V27.4A10.722,10.722,0,0,1,24.461,27.4ZM4.691,31.7H8.984v7.887H4.691Zm28.758,9.269H.683v-.7H33.449Z",
    transform: "translate(0 0)",
    fill: "#1c1c74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatWeDo3);
export default __webpack_public_path__ + "static/media/whatWeDo3.5638b8efe1bbe59c581ca3ce6745b082.svg";
export { ForwardRef as ReactComponent };